// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"130":"97066c6d","9438":"968bc449"}[chunkId] + ".chunk.css";
};